import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import {
  breakpoint,
  fontSize,
  size,
  width,
} from '@twistopayments/design-system/styles'

export const slider = css`
  position: relative;
  min-width: 100%;
  box-sizing: border-box;
  overflow: hidden;
`

export const carouselDescription = css`
  font-size: ${fontSize.smMd};
`

export const active = css`
  position: relative;
`

export const inner = css`
  margin: 0 auto;
  min-width: unset;
  width: ${width.container.large};
`

export const content = css`
  height: 100%;
`

export const hero = css`
  position: relative;
  overflow: visible;
  z-index: 2;
  border-radius: 0 ${size[80]} 0 0;
  padding: 0;
  margin: ${size[60]} 0;
  height: 100%;

  ${breakpoint.up('md')} {
    max-height: 60rem;
  }

  ${breakpoint.up('smMd')} {
    height: calc(100vh - 92px);
    margin: 0 0;
    border-radius: 20px 200px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  ${breakpoint.up('sm')} {
    background: 0 0;
  }

  ${breakpoint.down(48)} {
    margin-bottom: ${size[120]};
  }
`

export const heroCell = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  width: 100%;

  color: ${theme.palette.background.main};
`

export const cellContent = css`
  display: flex;
  flex-direction: column;
  align-self: center;
  align-items: center;
  max-width: ${width.container.wide};
  width: 100%;
  padding: 0 ${size[20]};

  ${breakpoint.up('smMd')} {
    padding: ${size[20]};
    text-align: center;
  }

  ${breakpoint.up(88)} {
    padding: 0;
  }
`

export const backgroundWrapper = css`
  position: absolute;
  inset: 0;
  z-index: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
`

const overlay = (theme: Theme) => css`
  background: ${theme.palette.primary.maxContrast}a0;
`

export const background = (hasGradient: boolean) => (theme: Theme) => css`
  position: relative;
  width: 100%;
  height: 100%;

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    z-index: 1;
    ${hasGradient && overlay(theme)}
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 0;
  }
`

export const cta = css`
  display: flex;
  flex-direction: column;
  row-gap: ${size[12]};

  margin-top: ${size[60]};
  width: 100%;

  a {
    width: 100%;
    outline: none;
  }

  ${breakpoint.up('smMd')} {
    flex-direction: row;
    column-gap: ${size[24]};
    width: fit-content;
  }
`
